import profilePic from '../../image/profile.jpeg';

export default function Hero({ t, typedText }) {
  return (
    <section id="home" className="premium-hero">
      <div className="hero-container">
        <div className="hero-left">
          <div className="profile-image-wrapper">
            <div className="profile-glow"></div>
            <img src={t.profileImg || profilePic} alt="Ahmet Oyan" />
            <div className="profile-status">
              <span className="status-dot"></span>
              <span className="status-text">Available for work</span>
            </div>
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-badge">
            <span className="badge-dot"></span>
            Hello, I'm
          </div>
          <h1 className="hero-title">
            Ahmet <span className="hero-title-accent">Oyan</span>
          </h1>
          <h2 className="hero-subtitle">
            {typedText}<span className="typing-cursor"></span>
          </h2>
          <p className="hero-about-text">{t.aboutText}</p>
          <div className="hero-cta">
            <a href="#projects" className="btn-primary">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/></svg>
              View My Work
            </a>
            <a href="#contact" className="btn-secondary">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
              Contact Me
            </a>
          </div>
        </div>
      </div>
      <div className="hero-scroll-indicator">
        <a href="#education-skills" aria-label="Scroll down">
          <div className="scroll-mouse">
            <div className="scroll-wheel"></div>
          </div>
        </a>
      </div>
    </section>
  );
}
